<template>
  <van-popup
    class="login-popup"
    :class="[
      layoutVersion,
      displayHorizontal ? 'horizontal' : '',
      isNewLayout ? 'new-version' : '',
    ]"
    v-model="showLoginPopup"
    round
    :closeable="isDesktop"
    :position="isDesktop ? 'center' : position ? position : 'bottom'"
    :safe-area-inset-bottom="true"
    @click-close-icon="handleClose"
    :get-container="parentContainer"
  >
    <div :class="['login-popup-wrapper', isMobile ? 'mobile' : 'desktop']">
      <!-- 横屏定制close按钮，后续其他的端依次修改 -->
      <MBIcon
        defaultClass="colour"
        name="c-close-grey"
        class="close"
        color="#D9D9D9"
        v-if="displayHorizontal"
        @click="showLoginPopup = false"
      />
      <p :class="['login-title', region]">
        {{ $t('common.login_toplupe') }}
      </p>
      <p :class="['login-subtitle', region]">
        {{ $t('common.login_subtitle') }}
      </p>
      <!-- 登录按钮 -->
      <button
        v-for="item in buttons"
        :key="item.name"
        :class="['login-btn', item.name]"
        @click="handleLogin(item.name)"
      >
        <img v-lazy="item.logoRound" alt="logo" />
        <span class="text">{{ item.title }}</span>
      </button>
    </div>
  </van-popup>
</template>

<script>
  import { initVK } from '@/utils/login/vk'
  import {
    getSignInUserInfo,
    getLoginUserInfoByApi,
    getLoginUserInfoByRedirect,
  } from '@/utils/login/index'
  import { mapMutations, mapState, mapGetters } from 'vuex'
  import { loginQuickSuccess, loginClick, loginQuick } from '@/pages/firebase'
  import bus from '@/utils/bus'
  import { appLogin, appLoginByWay } from '@/utils/native'
  import { LOGIN_TYPE } from '@/consts/index'
  import { session, cdvkKey } from '@/utils/storage'
  import { getCurrentPage } from '@/utils/utils.js'
  import MBIcon from '@/components/MBIcon'
  import { isMsaWebView, jumpBrowser } from '@/utils/msa'

  export default {
    name: 'login-btn',
    props: {
      position: {
        type: String,
        default: 'bottom',
      },
      parentContainer: {
        type: String,
      },
    },
    components: {
      MBIcon,
    },
    data() {
      return {
        showLoginPopup: false,
        buttonMap: {
          login: 'login',
          order: 'order',
          coupon: 'coupon',
          banner: 'banner',
          activity: 'act_id',
        },
      }
    },
    computed: {
      ...mapState([
        'userInfo',
        'isMobile',
        'region',
        'isDesktop',
        'gameName',
        'isApp',
        'layoutVersion',
      ]),
      ...mapState('detail', ['tuneUpLogin', 'isPierceLogoLayer']),
      ...mapGetters(['displayHorizontal', 'isNewLayout']),
      currentPage() {
        return getCurrentPage(this.$route.path)
      },
      buttons() {
        let list = [
          {
            name: 'google',
            title: this.$t('common.login_google'),
            logo: require(`@/assets/images/common/icon/login-google-icon.png`),
            logoRound: require(`@/assets/images/common/icon/google.png`),
          },
          {
            name: 'vk',
            title: 'VK',
            logo: require(`@/assets/images/common/icon/vk.png`),
            logoRound: require(`@/assets/images/common/icon/vk-c.png`),
          },
          // {
          //   name: 'facebook',
          //   title: this.$t('common.login_facebook'),
          //   logo: require(`@/assets/images/common/icon/login-facebook-icon.png`),
          //   logoRound: require(`@/assets/images/common/icon/facebook-c.png`),
          // },
        ]
        if (this.region === 'ru') {
          return list.filter((item) => ['google', 'vk'].indexOf(item.name) > -1)
        }
        if (isMsaWebView()) {
          // msa只保留google登录
          return list.filter((item) => ['google'].indexOf(item.name) > -1)
        }
        return list.filter(
          (item) => ['google', 'facebook'].indexOf(item.name) > -1
        )
      },
    },
    created() {
      if (!process.client) return
      bus.$on('login', this.loginBtn)
    },
    mounted() {
      if (isMsaWebView()) {
        // 在msa中，通过重定向方式登录
        getLoginUserInfoByRedirect('google')
          .then((res) => {
            // 调用服务端登录接口，同步数据
            this.showLoginPopup = false
            // 调用原来的方法实现打点等其他功能
            const params = { gaTrack: true, button: 'login' }
            this.appLoginCb(params, res)
          })
          .catch((err) => {
            this.$emit('login', { status: 0 })
            this.setLoginInfo({ exe: 1, status: 0 })
            const { code } = err
            if (String(code) === '1208') {
              // 永久封禁账号
              bus.$emit('account-risk', { errCode: code })
            }
          })
      }
    },
    beforeDestroy() {
      bus.$off('login')
      bus.$off('account-risk')
    },
    watch: {
      // 最外层vuex直接注入
      // 选择钱包支付通道直接调用
      isPierceLogoLayer(newValue) {
        if (newValue === -1) return
        this.loginBtn(newValue)
      },
      tuneUpLogin: {
        handler(newVal) {
          const { type = '', option = {} } = newVal
          if (type === '') return
          if (type === 'vk') {
            this.loginVK(option)
          } else {
            this.login(type, null, option)
          }
        },
        deep: true,
      },
    },
    methods: {
      ...mapMutations([
        'setUserInfo',
        'setLoginInfo',
        'detail/setIsPierceLogoLayer',
      ]),
      handleClose() {
        this['detail/setIsPierceLogoLayer'](-1)
      },
      handleLogin(name) {
        // 用户如果在msa中，则点击登录时调用浏览器
        if (isMsaWebView()) {
          const isJump = jumpBrowser(window.location.href)
          if (isJump) return
        }
        if (name === 'vk') {
          this.setvkCdLocation()
          this.loginVK()
        } else {
          this.login(name)
        }
        this.showLoginPopup = false
      },
      setvkCdLocation() {
        session.set(cdvkKey, window.location.href)
      },
      loginVK(options = {}) {
        if (this.isApp) {
          appLoginByWay('vk').then(() => this.appLoginCb(options))
          return
        }
        // 外部组件调用 loginBtn 传入的参数
        const { loginHandleType, buttonMap } = this
        const params = {
          button: buttonMap[loginHandleType],
          ...options,
        }
        session.set('trackParams', params)
        initVK(params)
      },
      loginBtn(data) {
        const { buttonMap } = this
        const typeOfByType = typeof data
        let button = 'login'
        let loginHandleType = 'login'
        if (typeOfByType === 'string') {
          button = buttonMap[data] || 'login'
          loginHandleType = data
        } else if (typeOfByType === 'object' && data.type === 'activity') {
          button = data.act_id
          loginHandleType = 'activity'
          buttonMap[loginHandleType] = data.act_id
        }
        this.loginHandleType = loginHandleType
        loginClick({ page: this.currentPage, button })
        if (this.isApp) {
          appLogin().then(() => this.appLoginCb(data))
        } else {
          this.showLoginPopup = true
        }
      },
      async login(type, code, options = {}) {
        if (this.isApp) {
          appLoginByWay(type).then(() => this.appLoginCb(options))
          return
        }
        // gaTrack：是否要打点，默认true
        const { gaTrack = true, button = '' } = options
        const { buttonMap } = this
        let buttonValue = buttonMap[this.loginHandleType] || 'login'
        gaTrack &&
          loginQuick({
            page: this.currentPage,
            login_way: type,
            button: button || buttonValue,
          })

        this.showLoginPopup = false
        this.setLoginInfo({ exe: 0, status: 0 })
        try {
          const userinfo = await getSignInUserInfo(type, code)
          // msa登录弹窗时，如果没有获取到用户信息，不继续往下走，否则会触发多次bus且会出现多次登录弹窗
          if (isMsaWebView() && !userinfo) return
          if (userinfo && userinfo.kicoinToken) {
            this.setUserInfo(userinfo)
            gaTrack &&
              loginQuickSuccess({
                page: this.currentPage,
                mode: userinfo.userStatus, // 1：首次登录/注册， 0:老用户,
                login_way: LOGIN_TYPE[userinfo.loginType * 1] || 'google',
                button: button || buttonValue,
              })

            this.$emit('login', {
              status: 1,
              userInfo: userinfo,
            })
            bus.$emit('login success', { status: 1 })
            this.setLoginInfo({ exe: 1, status: 1 })
          } else {
            this.$emit('login', {
              status: 0,
            })
            bus.$emit('login', { status: 0 })
            this.setLoginInfo({ exe: 1, status: 0 })
          }
        } catch (err) {
          this.$emit('login', { status: 0 })
          this.setLoginInfo({ exe: 1, status: 0 })
          const { code } = err
          if (String(code) === '1208') {
            // 永久封禁账号
            bus.$emit('account-risk', { errCode: code })
          }
        }
      },
      async appLoginCb(options = {}, loginUserInfo) {
        try {
          // 获取用户信息
          const userinfo = await getLoginUserInfoByApi(loginUserInfo)
          // gaTrack：是否要打点，默认true
          const { gaTrack = true, button = '' } = options
          const { buttonMap } = this
          let buttonValue = buttonMap[this.loginHandleType] || 'login'
          gaTrack &&
            loginQuick({
              page: this.currentPage,
              login_way: LOGIN_TYPE[userinfo.loginType * 1] || 'google',
              button: button || buttonValue,
            })
          if (userinfo && userinfo.kicoinToken) {
            this.setUserInfo(userinfo)
            gaTrack &&
              loginQuickSuccess({
                page: this.currentPage,
                mode: userinfo.userStatus, // 1：首次登录/注册， 0:老用户,
                login_way: LOGIN_TYPE[userinfo.loginType * 1] || 'google',
                button: button || buttonValue,
              })

            this.$emit('login', {
              status: 1,
              userInfo: userinfo,
            })

            bus.$emit('login success')
          } else {
            this.$emit('login', {
              status: 0,
            })
          }
        } catch (err) {
          this.$emit('login', { status: 0 })
          this.setLoginInfo({ exe: 1, status: 0 })
          const { code } = err
          if (String(code) === '1208') {
            // 永久封禁账号
            bus.$emit('account-risk', { errCode: code })
          }
        }
      },
    },
  }
</script>

<style scoped lang="scss" src="./index.scss"></style>
<style scoped lang="scss">
  @media screen and (min-device-width: 1080px) {
    @import './index_pc.scss';
  }
</style>
